(function () {
  "use strict";

  var root = document.documentElement;
  var productPage = document.body.classList.contains("template-product");
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var legacyHeadingNames = [
    "multicolumn",
    "collage",
    "blog posts",
    "featured blog",
    "image with text"
  ];

  function suppressLegacyProductContent() {
    if (!productPage) return;

    document.querySelectorAll("#MainContent > .shopify-section").forEach(function (section) {
      var identity = ((section.id || "") + " " + (section.className || "")).toLowerCase();
      var heading = section.querySelector("h1, h2, h3");
      var headingText = heading
        ? heading.textContent.trim().replace(/\s+/g, " ").toLowerCase()
        : "";
      var inheritedType = /__(featured-blog|blog-posts?|article|collage)/.test(identity);
      var placeholderHeading = legacyHeadingNames.indexOf(headingText) !== -1;
      var genericTicker = section.classList.contains("scrolling-text-section");

      if (inheritedType || placeholderHeading || genericTicker) {
        section.hidden = true;
        section.classList.add("cn-legacy-suppressed");
        section.setAttribute("aria-hidden", "true");
      }
    });
  }

  function classifyGallery() {
    if (!productPage) return;

    document.querySelectorAll("media-gallery").forEach(function (gallery) {
      var mediaList = gallery.querySelector(".product__media-list");
      if (!mediaList) return;

      var items = Array.prototype.filter.call(mediaList.children, function (item) {
        return item.classList.contains("product__media");
      });
      var editorial = items.find(function (item) {
        var mediaId = (item.getAttribute("data-media-id") || "").toLowerCase();
        return item.classList.contains("product__hero-only") || mediaId.indexOf("editorial") !== -1;
      });
      var packshotAssigned = false;

      items.forEach(function (item) {
        var kind;

        if (item === editorial) {
          kind = "editorial";
        } else if (!packshotAssigned) {
          kind = "packshot";
          packshotAssigned = true;
        } else {
          kind = "detail";
        }

        item.setAttribute("data-cn-media-kind", kind);
      });

      gallery.querySelectorAll(".product__thumbnail[data-media-id]").forEach(function (thumbnail) {
        var mediaId = thumbnail.getAttribute("data-media-id");
        var matchingMedia = items.find(function (item) {
          return item.getAttribute("data-media-id") === mediaId;
        });

        if (matchingMedia) {
          thumbnail.setAttribute(
            "data-cn-media-kind",
            matchingMedia.getAttribute("data-cn-media-kind")
          );
        }
      });

      gallery.setAttribute("data-cn-gallery-normalized", "true");
    });
  }

  function relocateAftercare() {
    if (!productPage) return;

    var main = document.querySelector("#MainContent");
    var aftercare = main && main.querySelector(".cn-aftercare");
    if (!main || !aftercare || aftercare.getAttribute("data-cn-relocated") === "true") return;

    var sections = Array.prototype.filter.call(
      main.querySelectorAll(":scope > .shopify-section"),
      function (section) {
        return section.getBoundingClientRect().height > 1 && !section.hidden;
      }
    );
    var technical = sections.filter(function (section) {
      return /technical/.test(((section.id || "") + " " + (section.className || "")).toLowerCase());
    });
    var system = sections.filter(function (section) {
      return /system|invisible/.test(((section.id || "") + " " + (section.className || "")).toLowerCase());
    });
    var details = sections.filter(function (section) {
      return (section.id || "").indexOf("__product-details") !== -1;
    });
    var target = technical[technical.length - 1] || system[system.length - 1] || details[details.length - 1];

    if (target) {
      target.insertAdjacentElement("afterend", aftercare);
      aftercare.setAttribute("data-cn-relocated", "true");
    }
  }

  function isPantherElement(element) {
    var identity = (
      (element.id || "") +
      " " +
      (element.className || "") +
      " " +
      (element.getAttribute("data-section-type") || "")
    ).toLowerCase();

    return identity.indexOf("panther") !== -1;
  }

  function prepareMotion() {
    var candidates = [];

    document.querySelectorAll("#MainContent > .shopify-section:not(:first-child)").forEach(function (section) {
      if (
        section.classList.contains("ciranova-luxury-story-section") ||
        section.querySelector(".home-dr-schutz")
      ) return;
      if (!section.querySelector(".product-card")) candidates.push(section);
    });

    document.querySelectorAll(
      ".cn-conversion-modules, .cn-assurance, .cn-aftercare, .template-collection .product-card"
    ).forEach(function (element) {
      candidates.push(element);
    });

    var unique = candidates.filter(function (element, index, list) {
      return list.indexOf(element) === index;
    }).filter(function (element) {
      return !element.hidden && !element.classList.contains("cn-legacy-suppressed") && !isPantherElement(element);
    });

    unique.forEach(function (element, index) {
      if (element.hasAttribute("data-cn-reveal")) return;
      element.setAttribute("data-cn-reveal", "");
      element.style.setProperty("--cn-reveal-delay", String((index % 4) * 55) + "ms");
    });

    root.classList.add("cn-motion-ready");

    if (reducedMotion || !("IntersectionObserver" in window)) {
      unique.forEach(function (element) {
        element.setAttribute("data-cn-revealed", "");
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute("data-cn-revealed", "");
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: "0px 0px -8% 0px",
      threshold: 0.08
    });

    unique.forEach(function (element) {
      if (!element.hasAttribute("data-cn-revealed")) observer.observe(element);
    });
  }

  function initCiranovaUi() {
    suppressLegacyProductContent();
    classifyGallery();
    relocateAftercare();
    prepareMotion();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCiranovaUi, { once: true });
  } else {
    initCiranovaUi();
  }

  document.addEventListener("shopify:section:load", initCiranovaUi);
})();
